import { InputLayoutElement } from './InputLayoutElement';

export class InputLayout {
  elements: InputLayoutElement[];

  constructor(elements: InputLayoutElement[]) {
    this.elements = elements;
  }
}
